import { InjectionToken } from '@angular/core';

export const DOCUMENT_REF = new InjectionToken<Document>('DOCUMENT_REF');
